import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthContext';
import { userCanAccessRoute } from '../utils/permissionCatalog';
import { ROUTE_PERMISSIONS } from '../utils/routePermissions';

export default function RequirePermission({ routeId, children }) {
  const { user } = useAuth();
  const requirement = ROUTE_PERMISSIONS[routeId];
  const allowed = userCanAccessRoute(user, requirement);

  if (!allowed) {
    if (routeId === 'stock') {
      return <Navigate to="/support" replace />;
    }
    return <Navigate to="/stock" replace />;
  }

  return children;
}
